import type { HashtagGroup, SelectedHashtag } from './rec-tuning-panel';
import { ChevronLeft } from 'lucide-react';
import { pickCss } from '@/shared/lib/css-utils';
import { RecTuningPanel } from './rec-tuning-panel';
import css from './rec-tuning-screen.module.scss';

const styles = {
  root: pickCss(css, css.root),
  header: pickCss(css, css.header),
  back: pickCss(css, css.back),
  title: pickCss(css, css.title),
  body: pickCss(css, css.body),
  footer: pickCss(css, css.footer),
  done: pickCss(css, css.done),
};

type RecTuningScreenProps = {
  selectedHashtags: ReadonlyArray<SelectedHashtag>;
  hashtagLibrary: ReadonlyArray<HashtagGroup>;
  onAddHashtag: (tag: string) => void;
  onRemoveHashtag: (tag: string) => void;
  onHashtagWeightChange: (tag: string, value: number) => void;
  onClose: () => void;
};

/**
 * RecTuningScreen — pen `tunScrn` (Step 2b). Full-screen drill-down from Day
 * picks for per-hashtag weight controls that apply globally across every day.
 */
export const RecTuningScreen = ({
  selectedHashtags,
  hashtagLibrary,
  onAddHashtag,
  onRemoveHashtag,
  onHashtagWeightChange,
  onClose,
}: RecTuningScreenProps) => (
  <div className={styles.root()}>
    <header className={styles.header()}>
      <button
        className={styles.back()}
        data-testid="close-recommendation-tuning"
        onClick={onClose}
        type="button"
      >
        <ChevronLeft aria-hidden="true" size={14} />
        Day picks
      </button>
      <span className={styles.title()}>Recommendation tuning</span>
      <span aria-hidden="true" style={{ width: 60 }} />
    </header>

    <div className={styles.body()}>
      <RecTuningPanel
        hashtagLibrary={hashtagLibrary}
        onAddHashtag={onAddHashtag}
        onHashtagWeightChange={onHashtagWeightChange}
        onRemoveHashtag={onRemoveHashtag}
        selectedHashtags={selectedHashtags}
      />
    </div>

    <footer className={styles.footer()}>
      <button className={styles.done()} onClick={onClose} type="button">
        Done — back to day picks
      </button>
    </footer>
  </div>
);
